import { isNonEmptyString } from "@cayuse/shared-react.utils.type-checks";

import { IS_DEV } from "globals/constants";
import { notifyError } from "utils";
import { findAllUserAccessesInProject } from "utils/accesses";
import { userAccesses as constants } from "store/constants";
import { actionLoaderFactory } from "store/factories/fetchable";

import { awardSelectors, proposalSelectors, subawardSelectors } from "../selectors";
import { api } from "services";


const { setData, setError, createLoaderAction } = actionLoaderFactory(constants, constants.USER_ACCESSES);

const getIds = formType => {
	let id = "";

	if (formType === "proposal") {
		const proposal = proposalSelectors.proposal();
		id = proposal.proposalId;
	}
	if (formType === "award") {
		const award = awardSelectors.award();
		id = award.awardId;
	}
	if (formType === "subaward") {
		const subaward = subawardSelectors.subaward();
		id = subaward.subawardId;
	}

	return id;
};

export const fetchCurrentProjectAccess = async formType => {
	const id = getIds(formType);

	if (isNonEmptyString(id) && isNonEmptyString(formType)) {
		return createLoaderAction(
			() => api.project.getAuthAccesses(id, formType),
			[
				response => {
					const currentProjectAccessTypes = response?.accessTypes || [];
					const parentSubmissionProjectAccessTypes = response?.parentAccessTypes || [];

					setData({ currentProjectAccessTypes, parentSubmissionProjectAccessTypes });
				},
				(error) => {
					const message = IS_DEV ? error.message : "An error occurred while loading accesses";
					notifyError(message, error);
					setError(message);
				},
			],
		);
	} else {
		setError("id and formType can not be empty.");
	}
};
